<template>
  <painel-component :items="itemsOne">
    <form>
      <row-component>
        <col-component class-col="col-xxl-2 col-xl-2 col-lg-3 col-md-12 col-sm-12 col-12">
          <label>N°:</label>
          <input-component v-model="formData.code" placeholder="N°" />
        </col-component>

        <col-component class-col="col-xxl-4 col-xl-4 col-lg-9 col-md-12 col-sm-12 col-12">
          <label>Cliente:</label>
          <div class="input-container">
            <input-component v-model="selectedClientName" placeholder="Cliente" disabled />
            <button-submit class="btn-modal-search" icon="search" @click="openModalClient = true" />
          </div>
        </col-component>

        <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
          <label>Responsável:</label>
          <MultiSelect v-model="formData.creator_user_id" placeholder="Responsável" :options="selectUserList" />
        </col-component>

        <col-component class-col="col-xxl-3 col-xl-3 col-lg-6 col-md-12 col-sm-12 col-12">
          <label>Status:</label>
          <MultiSelect v-model="formData.status" placeholder="Status" :options="selectStatusComplete" />
        </col-component>
      </row-component>

      <row-component>
        <col-component class-col="col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-12">
          <button-submit class="me-1" @click="submit" icon="search" name="Pesquisar" />
          <button-route v-if="buttonCheck.create" :items="itemsTwo" />
        </col-component>
      </row-component>
    </form>

    <div class="bg-body-secondaryd">
      <div class="bg-white">
        <div class="__table">
          <table class="table table-striped" v-if="viewPage">
            <thead>
              <tr>
                <th scope="col" style="width: 30%">Cliente</th>
                <th scope="col" style="width: 20%">Responsável</th>
                <th scope="col" style="width: 15%">Data - Hora</th>
                <th scope="col" style="width: 15%">Status</th>
                <th scope="col" style="width: 20%" v-if="buttonCheck.edit || buttonCheck.delete">Ações</th>
              </tr>
            </thead>

            <tbody>
              <tr v-for="(data, index) in object.data" :key="index">
                <td data-label="Cliente" class="name">
                  <img
                    v-if="data.client_photo"
                    class="image-desc rounded-circle me-2"
                    height="40"
                    width="40"
                    :src="data.client_photo"
                    alt=""
                  />
                  <img
                    v-else
                    class="image-desc rounded-circle me-2"
                    height="40"
                    width="40"
                    src="@/assets/avatar.png"
                    alt=""
                  />
                  {{ data.client_name }}
                </td>
                <td data-label="Responsável">
                  <img
                    v-if="data.creator_user_photo"
                    class="image-desc rounded-circle me-2"
                    height="35"
                    width="35"
                    :src="data.creator_user_photo"
                    alt=""
                  />
                  <img
                    v-else
                    class="image-desc rounded-circle me-2"
                    height="35"
                    width="35"
                    src="@/assets/avatar.png"
                    alt=""
                  />
                  {{ data.creator_user_name }}
                </td>
                <td data-label="Data - Hora">{{ data.date_hour }}</td>
                <td data-label="Status">{{ statusString(data.status) }}</td>
                <td data-label="Ações" v-if="buttonCheck.edit || buttonCheck.delete">
                  <button-edit v-if="buttonCheck.edit" :id="data.id" route="order-part-edit" />
                  <button-delete v-if="buttonCheck.delete" @click="destroy(data)" />
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <button-pagination :pagination="object" :offset="3" @paginate="loadItems" />

    <OrderPartClientSearch
      v-if="openModalClient"
      @close="openModalClient = false"
      @select="handleClientSelection"
    />
  </painel-component>
</template>

<script>
import PainelComponent from '@/components/dashboard/PainelComponent';
import RowComponent from '@/components/row/RowComponent';
import ColComponent from '@/components/row/ColComponent';
import InputComponent from '@/components/form/InputComponent';
import MultiSelect from '@/components/form/MultiSelect';
import ButtonSubmit from '@/components/buttons/ButtonSubmit';
import ButtonRoute from '@/components/buttons/ButtonRoute';
import ButtonEdit from '@/components/buttons/ButtonEdit';
import ButtonDelete from '@/components/buttons/ButtonDelete';
import ButtonPagination from '@/components/buttons/ButtonPagination';
import OrderPartClientSearch from '@/components/modal/OrderPartClientSearch.vue';
import '@/assets/css/table.css';

import { useToast } from 'vue-toastification';
import swal from 'sweetalert';

const toast = useToast();
export default {
  name: 'OrderPartSearch',

  components: {
    ButtonPagination,
    ButtonDelete,
    ButtonEdit,
    ButtonRoute,
    ButtonSubmit,
    MultiSelect,
    InputComponent,
    ColComponent,
    RowComponent,
    PainelComponent,
    OrderPartClientSearch
  },

  created() {
    this.$store.dispatch('changeNamePage', 'Pedido');
    this.$store.dispatch('loadSelectUser');
    this.loadItems(1);
    this.checkACL();
  },

  data() {
    return {
      itemsOne: {
        title: 'Pesquisar',
        icon: 'list alternate'
      },

      itemsTwo: {
        route: '/order-part/create',
        icon: 'plus',
        name: 'Adicionar'
      },

      buttonCheck: {
        create: false,
        edit: false,
        delete: false
      },

      formData: {
        code: '',
        client_id: '',
        creator_user_id: '',
        status: ''
      },

      selectedClientName: '',
      openModalClient: false,
      viewPage: false,
      searchSubmit: false
    };
  },

  methods: {
    submit() {
      this.loadItems(1);
      this.searchSubmit = true;
    },

    loadItems(page) {
      if (!this.searchSubmit) {
        this.$store
          .dispatch('loadOrderParts', { ...this.params, page })
          .then(r => {
            if (this.searchSubmit) {
              this.searchSubmit = false;
              if (r.data.length === 0) {
                toast.info('Nada foi encontrado com os parâmetros informados!', { timeout: 2000 });
              }
            }
          })
          .catch(() => {
            this.searchSubmit = false;
          });
      }
    },

    handleClientSelection(client) {
      this.formData.client_id = client.id;
      this.selectedClientName = client.surname || client.name;
      this.openModalClient = false;
    },

    async checkACL() {
      this.$store
        .dispatch('ACLItems', 8)
        .then(r => {
          if (r.indexOf('order-part-search') !== -1) {
            this.viewPage = true;

            if (r.indexOf('order-part-create') !== -1) {
              this.buttonCheck.create = true;
            }

            if (r.indexOf('order-part-edit') !== -1) {
              this.buttonCheck.edit = true;
            }

            if (r.indexOf('order-part-delete') !== -1) {
              this.buttonCheck.delete = true;
            }
          } else {
            this.$router.push({ name: 'home' });
          }
        })
        .catch(() => {
          this.$router.push({ name: 'home' });
        });
    },

    destroy(item) {
      swal({
        title: 'Atenção!',
        text: `Deseja realmente deletar o pedido ${item.code || ''} de ${item.client_name}?`,
        closeOnClickOutside: false,
        buttons: {
          cancel: {
            text: 'Não',
            visible: true,
            closeModal: true
          },
          confirm: 'Sim'
        }
      }).then(result => {
        if (result) {
          this.$store
            .dispatch('destroyOrderPart', item.id)
            .then(() => {
              this.loadItems(1);
              toast.success('Cadastro deletado com sucesso', { timeout: 1500 });
            })
            .catch(() => {
              toast.error('Não foi possível deletar o pedido', { timeout: 1500 });
            });
        }
      });
    },

    statusString(value) {
      const status = this.selectStatusComplete.find(item => Number(item.value) === Number(value));
      return status ? status.label : '';
    }
  },

  computed: {
    selectStatusComplete() {
      return this.$store.state.var.selectStatusComplete;
    },

    selectUserList() {
      return this.$store.state.var.selectUserList;
    },

    object() {
      return this.$store.state.order_part.items;
    },

    params() {
      return {
        page: this.object.current_page,
        code: this.formData.code,
        client_id: this.formData.client_id,
        creator_user_id: this.formData.creator_user_id,
        status: this.formData.status
      };
    }
  }
};
</script>

<style scoped>
.input-container {
  position: relative;
  display: flex;
  align-items: center;
}

.btn-modal-search {
  padding-top: 9.5px;
  padding-bottom: 5px;
}

@media (max-width: 991px) {
  .name {
    padding: 5px;
  }

  .image-desc {
    width: 35px;
    height: 35px;
  }
}
</style>
